module.exports = __webpack_public_path__ + "img/center003.f4b9d52a.jpg";